export default {
  common: {
    save: '저장',
    cancel: '취소',
    confirm: '확인',
    delete: '삭제',
    edit: '편집',
    view: '보기',
    back: '뒤로',
    close: '닫기',
    add: '추가',
    send: '보내기',
    sending: '전송 중...',
    saving: '저장 중...',
    loading: '로드 중...',
    search: '검색',
    update: '업데이트',
    create: '만들기',
    creating: '만드는 중...',
    transfer: '이전',
    approve: '승인',
    reject: '거부',
    ok: '알겠습니다',
    name: '이름',
    username: '사용자 이름',
    password: '비밀번호',
    email: '이메일',
    date: '날짜',
    status: '상태',
    type: '유형',
    quantity: '수량',
    description: '설명',
    project: '프로젝트',
    task: '작업',
    logout: '로그아웃',
    notifications: '알림',
    settings: '설정',
    draft: '초안',
    sent: '전송됨',
    active: '활성',
    inactive: '비활성',
    priority: '우선순위',
    language: '언어',
    yes: '예',
    no: '아니요',
    error: '오류',
    success: '성공',
    warning: '경고',
    required: '필수',
    optional: '선택',
    all: '전체',
    none: '없음',
    upload: '파일 업로드',
    download: '다운로드',
    print: '인쇄',
    actions: '작업',
    details: '세부 정보',
    filters: '필터',
    results: '결과',
    noResults: '결과를 찾을 수 없습니다',
    total: '합계',
    of: '/',
    verified: '인증됨',
    pending: '대기 중',
    completed: '완료됨',
    cancelled: '취소됨',
  },

  auth: {
    login: '로그인',
    loginTitle: '계정에 로그인',
    logout: '로그아웃',
    register: '등록',
    forgotPassword: '비밀번호를 잊으셨나요?',
    resetPassword: '비밀번호 재설정',
    usernameOrEmail: '사용자 이름 또는 이메일',
    enterPassword: '비밀번호를 입력하세요',
    enterUsername: '사용자 이름을 입력하세요',
    loginError: '사용자 이름 또는 비밀번호가 올바르지 않습니다.',
    sessionExpired: '세션이 만료되었습니다. 다시 로그인하세요.',
  },

  nav: {
    dashboard: '대시보드',
    overview: '개요',
    documents: '문서',
    viewDocuments: '문서 보기',
    manageProjects: '프로젝트 관리',
    viewProjects: '프로젝트 보기',
    manageUsers: '사용자 관리',
    viewUsers: '사용자 보기',
    manageWarehouse: '창고 관리',
    viewWarehouse: '창고 보기',
    manageMachinery: '기계 관리',
    viewMachinery: '기계 보기',
    manageSystem: '시스템 관리',
    projects: '프로젝트',
    myProjects: '내 프로젝트',
    myTasks: '내 작업',
    reports: '보고서',
    drawings: '도면',
    warehouse: '창고',
    checkStock: '재고 확인',
    requests: '요청',
    requestItem: '항목 요청',
    tickets: '티켓',
    messages: '메시지',
    adminMode: '관리자 모드',
    standardMode: '표준 모드',
    analystMode: '분석가 모드',
    createReport: '보고서 작성',
    createReports: '건설 보고서',
    dailyReport: '일일 건설 보고서',
    incidentReport: '사고 보고서',
    safetySection: '산업 안전',
    safetyDialog: '안전 대화',
    workPermit: '위험 작업 허가증',
    occurrenceReport: '발생 보고서',
    settingsMenu: '설정',
  },

  profile: {
    editProfile: '프로필 편집',
    displayName: '이름',
    usernameLabel: '사용자 이름',
    passwordLabel: '비밀번호',
    changePassword: '비밀번호 변경',
    appearance: '외관',
    lightMode: '라이트 모드',
    darkMode: '다크 모드',
    languageLabel: '언어',
    cropTitle: '프로필 사진 자르기',
    cropUse: '이 영역 사용',
    zoom: '확대/축소',
    currentPassword: '현재 비밀번호 확인',
    newPassword: '새 비밀번호',
    confirmNewPassword: '새 비밀번호 확인',
    emailVerified: '인증됨',
    emailChange: '변경',
    emailSendCode: '코드 전송',
    emailConfirm: '확인',
    emailResend: '← 코드 재전송',
    emailCancelChange: '취소',
    emailSending: '전송 중...',
    emailVerifying: '인증 중...',
    emailHint: '{email}로 코드를 전송했습니다. 받은 편지함과 스팸 폴더를 확인하세요.',
    emailSuccess: '이메일 {email}이(가) 성공적으로 인증되었습니다.',
    emailInvalidError: '유효한 이메일 주소를 입력하세요.',
    emailGenericError: '코드 전송 중 오류가 발생했습니다.',
    emailInvalidCode: '유효하지 않은 코드입니다.',
    passwordFillAll: '모든 비밀번호 필드를 입력하세요.',
    passwordWrong: '현재 비밀번호가 올바르지 않습니다.',
    passwordMismatch: '새 비밀번호 확인이 일치하지 않습니다.',
    saveFillAll: '이름과 사용자 이름을 입력하세요.',
    saveFinishPassword: '저장하기 전에 비밀번호 변경을 완료하거나 취소하세요.',
    avatarAlt: '프로필',
  },

  dashboard: {
    overview: '개요',
    myProjects: '내 프로젝트',
    myTasks: '내 작업',
    activeProjects: '진행 중인 프로젝트',
    completedTasks: '완료된 작업',
    pendingTasks: '대기 중인 작업',
    recentActivity: '최근 활동',
    noProjects: '프로젝트를 찾을 수 없습니다.',
    noTasks: '작업을 찾을 수 없습니다.',
    createProject: '프로젝트 만들기',
    projectName: '프로젝트 이름',
    startDate: '시작 날짜',
    endDate: '종료 날짜',
  },

  projects: {
    title: '프로젝트',
    newProject: '새 프로젝트',
    projectName: '프로젝트 이름',
    startDate: '시작',
    endDate: '종료',
    progress: '진행률',
    team: '팀',
    gantt: '간트 차트',
    files: '파일',
    tickets: '티켓',
    warehouse: '창고',
    dds: '안전 미팅',
    reports: '보고서',
    noProjects: '프로젝트가 없습니다.',
    deleteConfirm: '이 프로젝트를 삭제하시겠습니까?',
  },

  tasks: {
    title: '작업',
    newTask: '새 작업',
    taskName: '작업 이름',
    assignee: '담당자',
    dependencies: '종속성',
    duration: '기간 (일)',
    startDate: '시작',
    endDate: '종료',
    progress: '진행률',
    addProgress: '진행률 기록',
    noTasks: '작업이 없습니다.',
    blocked: '차단됨',
    inProgress: '진행 중',
    done: '완료',
    deleteConfirm: '이 작업을 삭제하시겠습니까?',
  },

  warehouse: {
    title: '창고',
    stock: '재고',
    requestItem: '항목 요청',
    requests: '요청',
    addItem: '항목 추가',
    itemName: '항목 이름',
    category: '카테고리',
    unit: '단위',
    available: '사용 가능',
    reserved: '예약됨',
    transferItem: '항목 이전',
    reportDamage: '손상 보고',
    provideEquipment: '장비 제공',
    noItems: '재고에 항목이 없습니다.',
    noRequests: '요청이 없습니다.',
    approveRequest: '요청 승인',
    rejectRequest: '요청 거부',
    requestStatus: {
      pending: '대기 중',
      approved: '승인됨',
      rejected: '거부됨',
      delivered: '배송됨',
    },
  },

  safety: {
    title: '안전',
    dds: '안전 미팅',
    ddsTitle: '일일 안전 대화',
    newDds: '새 안전 미팅',
    occurrences: '발생 사항',
    permits: '허가증',
    createDialog: '대화 만들기',
    createOccurrence: '발생 사항 기록',
    createPermit: '허가증 만들기',
    topic: '주제',
    presenter: '발표자',
    attendees: '참석자',
    date: '날짜',
    noSafety: '안전 기록이 없습니다.',
  },

  tickets: {
    title: '티켓',
    newTicket: '새 티켓',
    subject: '제목',
    category: '카테고리',
    openedBy: '작성자',
    assignedTo: '담당자',
    openTickets: '열린 티켓',
    closedTickets: '닫힌 티켓',
    noTickets: '티켓이 없습니다.',
    status: {
      open: '열림',
      inProgress: '진행 중',
      closed: '닫힘',
    },
  },

  users: {
    title: '사용자',
    newUser: '새 사용자',
    role: '직책',
    roles: {
      adminMaster: '마스터 관리자',
      adminObra: '현장 관리자',
      user: '사용자',
    },
    noUsers: '사용자가 없습니다.',
    deleteConfirm: '이 사용자를 삭제하시겠습니까?',
    manageRoles: '직책 관리',
    manageUsers: '사용자 관리',
    userList: '사용자 목록',
  },

  system: {
    title: '시스템 설정',
    siteName: '시스템 이름',
    logo: '로고',
    loginBackground: '로그인 배경',
    primaryColor: '기본 색상',
    save: '설정 저장',
    saved: '설정이 저장되었습니다.',
  },

  reports: {
    title: '보고서',
    daily: '일일 보고서',
    incident: '사고 보고서',
    noReports: '보고서가 없습니다.',
    createReport: '보고서 만들기',
    date: '날짜',
    author: '작성자',
    content: '내용',
  },

  machinery: {
    title: '중장비',
    newMachine: '새 장비',
    machineName: '이름',
    model: '모델',
    plate: '번호판',
    status: '상태',
    noMachinery: '장비가 없습니다.',
  },

  messenger: {
    title: '메시지',
    newMessage: '새 메시지',
    noMessages: '메시지가 없습니다.',
    typeMessage: '메시지를 입력하세요...',
    send: '보내기',
  },
}
